import { render } from "./AppFooter.vue?vue&type=template&id=50e8e793&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=50e8e793&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50e8e793"

export default script